module.exports = __webpack_public_path__ + "img/img-navbar-logo@2x.801b108f.png";